// NewAiPrompt/aiMaxTokens.js
//
// kelly-0915-description-ai-length-request-ignored: every AI Assistant request
// sent max_tokens: 1000 no matter what the user typed, so a prompt asking for
// "2 sentences" still had ~1000 tokens of headroom (backed further by the BE's
// "50-200 words" system prompt for descriptions) to run long. The prompt text
// itself is the source of truth for length intent — when it asks for a short
// answer (a sentence/word count, or words like "brief"/"short"), cap max_tokens
// low enough to backstop that even if the model doesn't fully comply.

const SHORT_INTENT_RE =
  /\b\d+\s*(sentences?|words?)\b|\b(one|two|a\s+few)\s+sentences?\b|\b(short|brief|concise|tweet|one[- ]liner|one[- ]line)\b/i;

export const DEFAULT_MAX_TOKENS = 1000;
export const SHORT_ANSWER_MAX_TOKENS = 120;

// Resolve the max_tokens to send for a given typed prompt. Returns the small
// backstop when the prompt's own wording asks for a short answer, else the
// existing default (unchanged behavior for every other prompt).
export function resolveMaxTokensForPrompt(promptText) {
  if (typeof promptText !== "string" || !SHORT_INTENT_RE.test(promptText)) {
    return DEFAULT_MAX_TOKENS;
  }
  return SHORT_ANSWER_MAX_TOKENS;
}
